import React from 'react';

const dog = (
  <svg
    width="1504"
    height="1063"
    viewBox="0 0 1504 1063"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M168.913 204.631L247.367 174.479C254.635 171.791 261.171 167.433 266.446 161.756C271.721 156.079 275.588 149.242 277.736 141.796C281.889 128.352 289.912 116.431 300.802 107.522L302.899 105.786L302.248 107.16C347.874 70.2109 434.137 81.7078 434.137 81.7078C450.464 83.6032 465.956 89.9463 478.924 100.045C491.892 110.144 501.837 123.611 507.674 138.976L538.477 220.611L586.49 268.623V268.189L604.711 286.339C606.68 286.461 608.638 286.727 610.568 287.134L613.822 287.929H614.545L615.991 288.363L618.594 289.086L626.476 291.256L631.537 292.702L644.263 296.172L650.843 298.052L658.074 300.005C658.383 300.079 658.705 300.079 659.014 300.005L670.511 303.331L723.223 317.792L732.045 320.179L740.722 322.637L749.109 324.951L805.437 340.642C808.893 341.569 812.427 342.175 815.994 342.449C850.485 344.691 1044.92 357.851 1118.67 372.457H1119.83C1121.64 371.156 1123.37 369.926 1125.11 368.552C1126.84 367.179 1128.65 365.877 1130.32 364.431C1141.28 355.507 1151.62 345.844 1161.26 335.508L1162.2 334.496C1167.26 329 1172.11 323.36 1176.66 317.648L1177.53 316.563C1182.09 310.996 1186.43 305.356 1190.55 299.571L1191.49 298.269C1192.43 297.04 1193.15 295.739 1194.02 294.509C1200.67 285.109 1206.82 275.492 1212.38 265.948C1212.68 265.481 1212.94 264.998 1213.18 264.502H1212.6L1213.11 263.634C1217.3 256.403 1221.28 249.172 1224.89 241.58C1227.21 236.808 1229.59 232.18 1232.12 227.119C1237.4 216.706 1242.83 205.932 1247.82 194.436C1253.27 182.489 1257.8 170.135 1261.34 157.486C1261.92 155.389 1262.42 153.22 1262.93 151.196C1265.53 138.805 1269.33 126.696 1274.28 115.042C1274.82 113.971 1275.65 113.072 1276.67 112.446C1277.69 111.82 1278.87 111.492 1280.06 111.499C1281.71 111.459 1283.3 112.065 1284.51 113.187C1285.71 114.309 1286.42 115.857 1286.5 117.5C1287.42 139.22 1286.65 160.978 1284.19 182.577C1280.32 213.358 1272.37 243.486 1260.54 272.166C1253.96 288.508 1248.03 301.812 1242.03 314.177V314.756H1241.45C1235.25 327.42 1228.4 339.753 1220.92 351.705C1218.82 354.959 1216.8 358.212 1214.63 361.466C1201.08 383.118 1185.72 403.582 1168.71 422.639C1179.89 448.127 1187.02 475.209 1189.82 502.9V503.768L1203.35 593.357C1207.44 609.053 1212.56 624.464 1218.68 639.489C1226.66 659.392 1236.64 678.434 1248.47 696.323V696.323C1260.52 714.879 1275.13 731.649 1291.85 746.143C1299.47 752.534 1304.88 761.161 1307.32 770.8C1318.1 812.739 1349.99 928.069 1350.35 929.226V930.022H1349.19C1349.55 931.323 1349.84 932.842 1350.13 934.36C1351.28 940.263 1351.11 946.349 1349.62 952.177C1348.13 958.005 1345.37 963.428 1341.53 968.056C1338.77 971.796 1335.24 974.892 1331.17 977.127C1327.1 979.362 1322.59 980.684 1317.95 980.999L1273.41 981.794C1268.37 982.222 1263.32 981.204 1258.83 978.861C1254.35 976.517 1250.63 972.945 1248.1 968.562C1246.25 964.681 1245.52 960.353 1246.02 956.079C1246.52 951.804 1248.22 947.759 1250.92 944.411C1254.91 939.636 1259.5 935.405 1264.59 931.829C1267.55 929.588 1270.38 927.173 1273.05 924.599L1250.64 855.473L1234.87 808.256L1169 768.197C1179.92 817.149 1195.83 934.505 1195.83 934.505C1200.82 958.583 1181.36 980.348 1164.16 980.348L1118.67 981.577C1093.37 981.577 1085.48 959.885 1096.98 945.423C1103.67 938.36 1110.93 931.855 1118.67 925.973L1095.1 797.337L984.182 717.943C969.307 702.402 955.762 685.64 943.689 667.834C943.689 667.834 696.47 665.737 619.245 666.966L640.937 789.022L645.637 815.342C646.143 820.403 633.562 894.88 630.814 911.366H631.248V911.945C631.248 912.668 622.499 979.553 581.139 979.553L533.994 981.433C516.496 981.433 505.577 977.239 501.745 969.068C497.913 960.897 501.383 949.4 510.856 937.831C519.031 929.762 528.916 923.633 539.779 919.899C545.982 917.605 551.941 914.698 557.567 911.222L568.051 867.837C573.043 846.186 571.508 823.54 563.64 802.76L537.393 733.996L517.58 682.006L485.982 832.117C484.775 837.668 482.855 843.039 480.27 848.097L441.079 923.948C435.077 942.82 423.363 965.091 401.527 965.091L358.142 966.899C318.517 966.899 324.519 941.229 337.317 924.309C346.717 911.945 364.939 907.173 377.014 899.653L399.574 860.245C411.328 839.71 417.951 816.641 418.88 792.999L427.991 565.591C426.197 559.649 424.725 553.615 423.58 547.514C421.043 531.811 419.906 515.913 420.182 500.008V471.085L395.091 429.869L343.102 344.546C340.754 340.625 337.426 337.384 333.445 335.139C329.464 332.895 324.967 331.726 320.397 331.748H309.551L310.636 331.169H304.2L258.068 330.663L258.574 331.242H230.519C208.827 331.242 192.413 325.529 180.844 312.876C169.274 300.222 162.188 280.916 159.151 253.728C159.08 252.934 159.08 252.135 159.151 251.342C159.151 250.619 159.151 249.823 159.151 249.1L153.873 226.757C153.668 221.942 155.021 217.19 157.73 213.204C160.439 209.219 164.36 206.212 168.913 204.631V204.631Z"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M356.262 313.599C356.262 313.599 359.299 313.599 364.577 314.322"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M394.221 314.105C428.205 311.502 476.579 299.643 502.682 256.259"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="18.5 30.83"
    />
    <path
      d="M509.4 243.316C510.461 240.809 511.473 238.206 512.437 235.506"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M517.356 681.573L427.839 565.736"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="17.37 29.03"
    />
    <path
      d="M1168.99 767.836L1199.14 565.736"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="17.37 29.03"
    />
    <path
      d="M619.02 666.967C619.02 666.967 688.147 517.145 649.1 483.667C610.054 450.188 553.51 396.753 456.328 448.598"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="17.37 29.03"
    />
    <path
      d="M540.353 292.412C540.353 292.412 715.988 511.794 1084.11 400.006"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="17.37 29.03"
    />
    <path
      d="M952.508 623.654C952.508 623.654 972.537 550.624 1084.11 507.962C1183.17 469.711 1190.04 500.731 1190.04 500.731"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="17.37 29.03"
    />
    <path
      d="M812.241 666.75C812.241 666.75 745.573 532.113 810.65 455.756"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="17.37 29.03"
    />
    <path
      d="M1168.42 421.916L1118.89 373.036"
      stroke="#77ACF1"
      strokeWidth="15.04"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="17.37 29.03"
    />
  </svg>
);

export default dog;
